import { render, staticRenderFns } from "./flexbox-item.vue?vue&type=template&id=c89cc374"
import script from "./flexbox-item.vue?vue&type=script&lang=js"
export * from "./flexbox-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./flexbox-item.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports